import {component} from '../form/Constant'

export const securityList = [
    {
        key: 'changePassword',
        children: [
            {
                key: 'newPassword',
                component: component.password,
                placeholder: 'Input new password',
            },
            {
                key: 'retypePassword',
                component: component.password,
                placeholder: 'Retype new password',
            },
        ],
    },
]
